import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  labelName: string;
  labelType: string;
}

@Component({
  selector: "sales-documents-dialog",
  templateUrl: "sales-documents-dialog.html",
})
export class SalesDocumentDialog {
  txtValue: String;
  result: DialogData = {
   labelName: null,
    labelType: null,
  };

  constructor(
    public dialogRef: MatDialogRef<SalesDocumentDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.result = Object.assign(this.result, data);

  }

  save() {
    if (!this.txtValue) return;
    this.dialogRef.close(this.txtValue);
  }
  close() {
    this.dialogRef.close();
  }
}
